var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-footer-nav",
      class: { rtl: _vm.dir === "rtl", "ns-minimal-footer-nav": _vm.minimal }
    },
    [
      _c(
        "div",
        { staticClass: "ns-footer-nav-mobile" },
        _vm._l(_vm.localNavigation, function(navItem) {
          return _c(
            "div",
            {
              key: navItem.title,
              staticClass: "nav-item--mobile",
              class: {
                "nav-item--mobile--active":
                  _vm.openNavItemTitle === navItem.title
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "nav-item-panel",
                  on: {
                    click: function($event) {
                      return _vm.handleNavItemClick(navItem.title)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "nav-item-title" }, [
                    _vm._v(_vm._s(navItem.title))
                  ]),
                  _vm._v(" "),
                  _c("NsIcon", {
                    staticClass: "nav-item-icon",
                    class: {
                      "nav-item-icon--active":
                        _vm.openNavItemTitle === navItem.title
                    },
                    attrs: {
                      "icon-name": "icon-narrow-angle-bottom-24",
                      size: "custom"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "NsAnimateHeight",
                { attrs: { open: _vm.openNavItemTitle === navItem.title } },
                [
                  _c(
                    "div",
                    { staticClass: "nav-item-links" },
                    _vm._l(navItem.links, function(linkItem) {
                      return _c(
                        "div",
                        { key: linkItem.name, staticClass: "nav-item-link" },
                        [
                          _c("a", {
                            staticClass: "nav-item-link-anchor",
                            attrs: {
                              href: _vm.getFullyQualifiedUrl(linkItem.href)
                            },
                            domProps: { innerHTML: _vm._s(linkItem.name) }
                          })
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ns-footer-nav-desktop" },
        _vm._l(_vm.localNavigation, function(navItem) {
          return _c("div", { key: navItem.title, staticClass: "nav-item" }, [
            _c("div", { staticClass: "nav-item-title" }, [
              _vm._v(_vm._s(navItem.title))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "nav-item-links" },
              _vm._l(navItem.links, function(linkItem) {
                return _c(
                  "div",
                  { key: linkItem.name, staticClass: "nav-item-link" },
                  [
                    _c("a", {
                      staticClass: "nav-item-link-anchor",
                      attrs: { href: _vm.getFullyQualifiedUrl(linkItem.href) },
                      domProps: { innerHTML: _vm._s(linkItem.name) }
                    })
                  ]
                )
              }),
              0
            )
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }